// Components
import EmptyBody from "@Layouts/components/Basics/EmptyBody";
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import { PerformanceTable } from "@DataPages/components/ServiceOperations/Tabs/TechnicianFlaggedTime/Tables/PerformanceTable";

// Assets
import emptyTable from "@/assets/images/commons/empty_table.png";

// Types
import { ITechnicianFlaggedTime, ITechnicianFlaggedTimeBase } from "@/DataPages/types/technicianFlaggedTime/model";

interface ITechnicianFlaggedTimeModelTableProps {
	data: ITechnicianFlaggedTime | null;
	isLoading: boolean;
	hasNextPage: boolean;
	technicianPerformance: ITechnicianFlaggedTimeBase | null;
}
export const TFTModelTable = (props: Readonly<ITechnicianFlaggedTimeModelTableProps>) => {
	const { data, isLoading, hasNextPage, technicianPerformance } = props;

	if (isLoading) {
		return <TableLoader toolbar buttons={3} content rows={5} multiTitles={5} />;
	}

	if (!data?.repairOrders?.length) {
		return (
			<EmptyBody
				image={emptyTable}
				title={"No Technician Flagged Time to show"}
				bodyHeightClassName={"!h-[400px]"}
				className="!shadow-none"
			/>
		);
	}

	return <PerformanceTable data={data?.repairOrders ?? []} hasNextPage={hasNextPage} technicianPerformance={technicianPerformance} />;
};
